import { API_URL, setHeader } from 'api';
import axios from 'axios';
import map from 'lodash/map';

const URL = `${API_URL}/prescreening`;

export const fetchPrescreenQuestions = params => {
  const req = setHeader(axios);
  return req.get(`${URL}`, { params });
};

export const reorderPrescreeningQuestions = questions => {
	const req = setHeader(axios);
	const justOrderStuff = questions.map(q => {
		return {
			questionID: q.questionID,
			displayOrder: q.displayOrder
		}
	});
	return req.post(`${URL}/questionorder`, {
		questions: justOrderStuff
	});
};

export const fetchPrescreenInstance = id => {
  const req = setHeader(axios);
  return req.get(`${URL}/instance/${id}`);
};

export const createPrescreenQuestion = obj => {
  const req = setHeader(axios);
  return req.post(`${URL}/question`, {
    question: obj.question,
    answerLimit: obj.answerLimit.label
      ? obj.answerLimit.value
      : obj.answerLimit,
    answers: map(obj.answers, a => {
      return {
        answer: a.answer,
        displayCategory: map(a.displayCategory, d => d.categoryID),
      };
    }),
  });
};

export const updatePrescreenQuestion = obj => {
  const req = setHeader(axios);
  return req.put(`${URL}/question`, {
    questionID: obj.questionID,
    updatedQuestion: obj.question,
    answerLimit:
      obj.answerLimit.value || obj.answerLimit.value === 0
        ? obj.answerLimit.value
        : obj.answerLimit,
    originalID: obj.originalID ? obj.originalID : obj.questionID,
  });
};

export const updatePrescreenDraftQuestion = obj => {
  const req = setHeader(axios);
  return req.put(`${URL}/question/draft`, {
    questionID: obj.questionID,
    question: obj.question,
    answerLimit: obj.answerLimit.value
      ? obj.answerLimit.value
      : obj.answerLimit,
  });
};

export const createPrescreenAnswer = (obj, questionID) => {
  const req = setHeader(axios);
  return req.post(`${URL}/answer`, {
    answer: obj.answer,
    questionID,
    displayCategory: map(obj.displayCategory, c => c.categoryID),
  });
};

export const updatePrescreenAnswer = (obj, questionID) => {
  const req = setHeader(axios);
  return req.put(`${URL}/answer`, {
    answerID: obj.answerID,
    updatedAnswer: obj.answer,
    originalID: obj.originalID ? obj.originalID : obj.answerID,
    questionID,
    displayCategory: map(obj.displayCategory, c => c.categoryID),
  });
};

export const updatePrescreenDraftAnswer = (obj, questionID) => {
  const req = setHeader(axios);
  return req.put(`${URL}/answer/draft`, {
    answerID: obj.answerID,
    answer: obj.answer,
    questionID,
    displayCategory: map(obj.displayCategory, c => c.categoryID),
  });
};

export const archivePrescreenQuestion = (id, status) => {
  const req = setHeader(axios);
  if (status === 'Active') {
    return req.put(`${URL}/question/${id}`);
  } else {
    return req.delete(`${URL}/question/draft/${id}`);
  }
};

export const archivePrescreenAnswer = (id, status) => {
  const req = setHeader(axios);
  if (status === 'Active') {
    return req.put(`${URL}/answer/${id}`);
  } else {
    return req.delete(`${URL}/answer/draft/${id}`);
  }
};

export const publishPrescreenQuestions = () => {
  const req = setHeader(axios);
  return req.put(`${URL}/publish`);
};
